if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        this.hydrate();
        super.show(opener);
        this.showActiveMedia();
      }

      // Move the deferred media markup from <template> into the modal's
      // content container the first time the modal opens. Subsequent opens
      // skip this. Keeps the (often 6+) high-res modal images out of the
      // initial PDP network payload.
      hydrate() {
        if (this.hasAttribute('data-hydrated')) return;
        const template = this.querySelector('template[data-product-media-modal-template]');
        const container = this.querySelector('[role="document"]');
        if (!template || !container) return;
        container.appendChild(template.content.cloneNode(true));
        template.remove();
        this.setAttribute('data-hydrated', 'true');
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
